
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { MedicationInventory } from "../../interfaces/pharmacy";
import { ColumnType, ButtonType } from "../../shared/utils/enums";
import { Edit, Package } from "lucide-react";

export const getPharmacyInventoryColumns = (
    onEdit: (row: MedicationInventory) => void,
    onOrder: (row: MedicationInventory) => void
): TableColumnsItem[] => [
    { key: "medicationName", name: "Medication Name", type: ColumnType.TEXT, cardTitle: true },
    { key: "genericName", name: "Generic Name", type: ColumnType.TEXT },
    { key: "dosageForms", name: "Dosage Forms", type: ColumnType.TEXT },
    { key: "currentStock", name: "Current Stock", type: ColumnType.TEXT },
    { key: "status", name: "Status", type: ColumnType.STATUS },
    { key: "supplier", name: "Supplier", type: ColumnType.TEXT },
    {
      key: "actions",
      name: "Actions",
      type: ColumnType.BUTTON,
      buttonsList: [
        {
          type: ButtonType.ICON,
          icon: Edit,
          onPress: (e: React.MouseEvent, row: MedicationInventory) => onEdit(row),
        },
        {
          type: ButtonType.ICON,
          icon: Package,
          onPress: (e: React.MouseEvent, row: MedicationInventory) => onOrder(row),
          tooltip: "Order Stock",
        },
      ],
    },
]; 